import { BlurEvent, DataDisplayEvent, DropdownSelectionEvent, LookupModelSearchEvent, ValidationResult } from "@mcleod/components";
import { AutogenLayoutOnTimeDetail } from "./autogen/AutogenLayoutOnTimeDetail";
import { ModelRow, StringUtil } from "@mcleod/core";

const ONTIME = "O";
const LATE = "L";
const FAILURES = "F";
const NOFAIL = "N";

export class OnTimeDetail extends AutogenLayoutOnTimeDetail {
    override onLoad() {
        this.textboxAdditionalWeight.addlValidationCallback = () => this.negativeValueValidator(this.textboxAdditionalWeight.text);
    }

    private negativeValueValidator(value: string): ValidationResult {
            const result: ValidationResult = {
                component: this.textboxAdditionalWeight,
                isValid: true
            };
            const numericValue = parseFloat(value);
            if (!isNaN(numericValue) && numericValue >= 0) {
                result.isValid = false;
                result.validationMessage = "Additional weight must be a negative value.";
            }
            return result;
    }


    textboxMeasureOnDataDisplay(event: DataDisplayEvent){
        const measure = event.rowData.get("measure");
        this.syncLayoutWithMeasure(measure, event.rowData);
    }

    textboxMeasureAfterDropdownSelection(event: DropdownSelectionEvent) {
        const measure = event.selection?.value;
        this.syncLayoutWithMeasure(measure, null);
    }

    syncLayoutWithMeasure(measure: string, modelRow: ModelRow) {
        const isNull = StringUtil.isEmptyString(measure);
        const isOnTime = measure === ONTIME;
        const isLate = measure === LATE;
        const isFailures = measure === FAILURES;
        const isNoFail = measure === NOFAIL;
        this.panelNoMeasure.visible = isNull;
        this.panelLateStops.visible = isLate;
        this.panelGracePeriod.visible = isOnTime || isLate;
        this.panelGracePeriod.rowBreak = isLate;
        this.checkboxExcludeServiceFailureNf.visible = isFailures;
        this.checkboxExcludeServiceFailureNf.rowBreak = this.checkboxExcludeServiceFailureNf.visible;
        this.panelOnTime.visible = isOnTime;
        this.panelLate.visible = isLate;
        this.panelIncidents.visible = isFailures;
        this.panelNoIncident.visible = isNoFail;
        this.textboxAverageMinutesLate.required = this.panelLateStops.visible && 
            modelRow ? modelRow.get("additional_weight") != null : !StringUtil.isEmptyString(this.textboxAdditionalWeight.text);
    }

    textboxOrderTypeBeforeLookupModelSearch(event: LookupModelSearchEvent) {
        event.filter.is_active = 'Y';
    }

    textboxCustomerIdBeforeLookupModelSearch(event: LookupModelSearchEvent) {
        event.filter.is_active = 'Y';
    }

    textboxAdditionalWeightOnBlur(event: BlurEvent) {
        this.textboxAverageMinutesLate.required = !StringUtil.isEmptyString(this.textboxAdditionalWeight.text);
    }
}